export const NON_PRODUCTION_DOMAIN_PARTIALS = [
    'localhost',
    'preview.zocdoc.com',
    'staging.zocdoc.com',
    'zocdoccloud.net',
];

const INFERRED_HOSTNAME = typeof window !== 'undefined' ? window.location.hostname : '';

/**
 * To use this function in SSR, you must pass in the hostname explicitly
 * since it cannot be inferred via `window.location`.
 */
export const isProduction = (hostname = INFERRED_HOSTNAME) =>
    NON_PRODUCTION_DOMAIN_PARTIALS.some(siteName => hostname.includes(siteName)) === false;
